import "./App.css";
import "antd/dist/reset.css";
import "./fonts/PoppinsRegular.ttf";
import "./fonts/Poppins-Black.ttf";
import "./fonts/Poppins-BlackItalic.ttf";
import "./fonts/Poppins-Bold.ttf";
import "./fonts/Poppins-ExtraBoldItalic.ttf";
import "./fonts/Poppins-ExtraLight.ttf";
import "./fonts/Poppins-ExtraLightItalic.ttf";
import "./fonts/Poppins-Italic.ttf";
import "./fonts/Poppins-LightItalic.ttf";
import "./fonts/Poppins-Medium.ttf";
import "./fonts/Poppins-MediumItalic.ttf";
import "./fonts/Poppins-SemiBold.ttf";
import "./fonts/Poppins-SemiBoldItalic.ttf";
import "./fonts/Poppins-Thin.ttf";
import "./fonts/Poppins-ThinItalic.ttf";
import "./fonts/Poppins-Light.ttf";
import "./fonts/Poppins-BoldItalic.ttf";
import "./fonts/Poppins-ExtraBold.ttf";
import MobileOTP from "./pages/Register/MobileOTP/MobileOTP";
import PersonalDetail from "./pages/Register/PersonalDetail/PersonalDetail";
import ChooseProd from "./pages/Register/ChooseProd/ChooseProd";
import { Helmet } from "react-helmet";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import InvestPref from "./pages/Register/InvestPref/InvestPref";
import MyPolicy from "./pages/Register/MyPolicy/MyPolicy";
import PhDashboard from "./pages/Dashboard/PhDashboard";
import PolicyDetails from "./pages/Register/PolicyDetails/PolicyDetails";
import InvestorKYC from "./pages/Register/InvestorKYC/InvestorKYC";
import PageNotFound from "./pages/Helper/PageNotFound";
import CompletePHProfile from "./pages/Register/CompletePHProfile/CompletePHProfile";
import InvestorDashboard from "./pages/Dashboard/InvestorDashboard/InvestorDashboard";
import PolicyCenter from "./pages/Dashboard/Marketplace/marketplace";
import AddPolicy from "./pages/Register/AddPolicy/addPolicy";
import PartnerRegistraion from "./pages/Register/PartnerRegistraion";
import { useEffect } from "react";
import PartnerDashboard from "./pages/Dashboard/PartnerDashboard/PartnerDashboard";
import ReferPage from "./pages/Register/ReferPage/ReferPage";
import ProfilePage from "./pages/Dashboard/profile/profilePage";
import Auth from "./components/Auth";
import { INVESTOR, PARTNER, POLICY_MASTER } from "./utils";
import PolicyReferral from "./pages/Dashboard/PolicyReferral/PolicyReferral";
import callsupport from "./svg/callsupport.png";
import Ldms from "./pages/Ldms/ldms";
import PartnerRegistraionNew from "./pages/Register/PartnerRegistraion/PartnerRegistrationScreen";
import RouteGaurd, { RestrictedLDMS } from "./middlewares/RouteGaurd";
import Checkout from "./pages/order/checkout";
import Response from "./pages/order/response";
import Billdesk, { billFun } from "./billdesk";
import LdmsInvestor from "./pages/Ldms/LdmsInvestor";
import AssignmentTracker from "./pages/Dashboard/InvestorDashboard/AssignmentTracker";
import InvestorMaturedPolicies from "./pages/Dashboard/MaturedPolicies/InvestorMaturedPolicies";
import PHMaturedPolicies from "./pages/Dashboard/MaturedPolicies/PHMaturedPolicies";
import UnauthorizedPage from "./pages/Helper/unauthorizedPage";
import LdmsManual from "./pages/Ldms/LdmsManual";
import PartnerOutlet from "./pages/Dashboard/PartnerDashboard/PartnerOutlet";
import PartnerInvestorByIdView from "./pages/Dashboard/PartnerDashboard/sub/PartnerInvestorByIdView";
import PartnerEarnings from "./pages/Dashboard/PartnerDashboard/sub/PartnerEarnings";
import LoanTrack from "./pages/Dashboard/LoanTrack";
import PanValidation from "./pages/Dashboard/PanValidation";
import EmailValidation from "./pages/Dashboard/EmailValidation";
import EnforcedIllustration from "./pages/EnforcedIllustration/EnforcedIllustration";
import DOGH from "./pages/Dogh/Dogh";
import LoanProcess from "./pages/Dashboard/LoanProcess";
import LoanForm from "./pages/Dashboard/LoanForm";

function App() {
  const environment =
    process.env.REACT_APP_ENV && String(process.env.REACT_APP_ENV) === "stage";

  useEffect(() => {});

  return (
    <div>
      {billFun(environment)}

      <Helmet>
        <link
          href="https://cdn.jsdelivr.net/npm/bootstrap@5.2.2/dist/css/bootstrap.min.css"
          rel="stylesheet"
        />
        <link
          href="https://getbootstrap.com/docs/5.2/assets/css/docs.css"
          rel="stylesheet"
        />
        <link
          rel="stylesheet"
          href="https://maxcdn.bootstrapcdn.com/font-awesome/4.6.1/css/font-awesome.min.css"
        />
        {/* <link id="bootstrap-css" href="//maxcdn.bootstrapcdn.com/bootstrap/4.1.1/css/bootstrap.min.css" rel="stylesheet"/> */}
        <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.2.2/dist/js/bootstrap.bundle.min.js" />
      </Helmet>
      <BrowserRouter>
        <Routes>
          <Route
            exact
            path="/"
            element={
              <Auth allow="$unauthenticated" redirectTo={"/"}>
                <MobileOTP />
              </Auth>
            }
          />
          <Route 
          exact path="/ldms" element={<LdmsManual />} />
          
          
          <Route
            exact
            path="/ldms-profile"
            element={
              // <RouteGaurd>
              <LdmsInvestor></LdmsInvestor>
              // </RouteGaurd>
            }
          />
          <Route
            exact
            path="/personaldetails"
            element={
              <Auth allow="$authenticated" permission="all" redirectTo={"/"}>
                <PersonalDetail />
              </Auth>
            }
          />
          <Route
            exact
            path="/enforced-illustration"
            element={
              <RouteGaurd>
                <EnforcedIllustration />
              </RouteGaurd>
            }
          />
          <Route exact path="/chooseproduct" element={<ChooseProd />} />
          <Route
            exact
            path="/investPref"
            element={
              <Auth allow="$authenticated" permission="all" redirectTo={"/"}>
                <InvestPref />
              </Auth>
            }
          />
          <Route
            exact
            path="/phdashboard/loan/:id"
            element={
              <Auth
                allow="$authenticated"
                permission={POLICY_MASTER}
                redirectTo={"/"}
              >
                <LoanTrack />
              </Auth>
            }
          />
          <Route
            exact
            path="/phdashboard/loan/email-validation"
            element={
              <Auth
                allow="$authenticated"
                permission={POLICY_MASTER}
                redirectTo={"/"}
              >
                <EmailValidation />
              </Auth>
            }
          />
          <Route
            exact
            path="/phdashboard/loan/pan-validation"
            element={
              <Auth
                allow="$authenticated"
                permission={POLICY_MASTER}
                redirectTo={"/"}
              >
                <PanValidation />
              </Auth>
            }
          />
           <Route
            exact
            path="/phdashboard/loan/loan-form"
            element={
              <Auth
                allow="$authenticated"
                permission={POLICY_MASTER}
                redirectTo={"/"}
              >
                <LoanForm />
              </Auth>
            }
          />
          <Route
            exact
            path="/loanprocess"
            element={
              <Auth
                allow="$authenticated"
                permission={POLICY_MASTER}
                redirectTo={"/"}
              >
                <LoanProcess />
              </Auth>
            }
          />
          <Route
            exact
            path="/add-policy"
            element={
              <Auth allow="$authenticated" permission="all" redirectTo={"/"}>
                <AddPolicy />
              </Auth>
            }
          />
          <Route
            exact
            path="/myPolicy"
            element={
              <Auth
                allow="$authenticated"
                permission={POLICY_MASTER}
                redirectTo={"/"}
              >
                <MyPolicy />
              </Auth>
            }
          />

          <Route
            exact
            path="/phDashboard"
            element={
              <Auth
                allow="$authenticated"
                permission={POLICY_MASTER}
                redirectTo={"/"}
              >
                <PhDashboard />
              </Auth>
            }
          />
          <Route
            exact
            path="/investorDashboard"
            element={
              <Auth
                allow="$authenticated"
                permission={INVESTOR}
                redirectTo={"/"}
              >
                <InvestorDashboard />
              </Auth>
            }
          />
          <Route
            exact
            path="/myearnings"
            element={
              <Auth
                allow="$authenticated"
                permission={PARTNER}
                redirectTo={"/"}
              >
                <PartnerEarnings />
              </Auth>
            }
          />

          <Route
            exact
            path="/assignmentTracker"
            element={
              <Auth
                allow="$authenticated"
                permission={INVESTOR}
                redirectTo={"/"}
              >
                <AssignmentTracker />
              </Auth>
            }
          />
          <Route
            exact
            path="/policyreferral"
            element={
              <Auth
                allow="$authenticated"
                permission={PARTNER}
                redirectTo={"/"}
              >
                <PolicyReferral />
              </Auth>
            }
          />

          <Route
            path="/partnerDashboard"
            element={
              <Auth allow="$authenticated" permission={PARTNER} redirectTo="/">
                <PartnerOutlet />
              </Auth>
            }
          >
            <Route index element={<PartnerDashboard />} />
            {/* <Route path="investor" element={<InvestorView />} /> */}
            <Route
              path="investor/:investorId"
              element={<PartnerInvestorByIdView />}
            />
            {/* <Route path="policy_master/:phId" element={<PolicyMaster />} /> */}
          </Route>
          {/* <Route
            exact
            path="/partnerDashboard"
            element={
              <Auth
                allow="$authenticated"
                permission={PARTNER}
                redirectTo={"/"}
              >
                <PartnerDashboard />
              </Auth>
            }
          /> */}
          <Route
            exact
            path="/referPage"
            element={
              <Auth
                allow="$authenticated"
                permission={PARTNER}
                redirectTo={"/"}
              >
                <ReferPage />
              </Auth>
            }
          />

          <Route
            exact
            path="/policycenter"
            element={
              <Auth
                allow="$authenticated"
                permission={INVESTOR}
                redirectTo={"/"}
              >
                <PolicyCenter />
              </Auth>
            }
          />

          <Route
            exact
            path="/policyDetails"
            element={
              <Auth
                allow="$authenticated"
                permission={POLICY_MASTER}
                redirectTo={"/"}
              >
                <PolicyDetails />
              </Auth>
            }
          />
          <Route
            exact
            path="/investorKyc"
            element={
              <Auth
                allow="$authenticated"
                permission={INVESTOR}
                redirectTo={"/"}
              >
                <InvestorKYC />
              </Auth>
            }
          />
          <Route
            exact
            path="/completePHProfile"
            element={
              <Auth
                allow="$authenticated"
                permission={POLICY_MASTER}
                redirectTo={"/"}
              >
                <CompletePHProfile />
              </Auth>
            }
          />

          <Route
            exact
            path="/partner-registration"
            element={
              <Auth allow="$authenticated" permission="all" redirectTo={"/"}>
                <PartnerRegistraionNew />
              </Auth>
            }
          />

          <Route
            exact
            path="/profile"
            element={
              <Auth allow="$authenticated" permission="all" redirectTo={"/"}>
                <ProfilePage />
              </Auth>
            }
          />
          <Route path="/forbidden" element={<UnauthorizedPage />} />
          <Route
            exact
            path="investor/matured-policies"
            element={
              <Auth allow="$authenticated" permission="all" redirectTo={"/"}>
                <InvestorMaturedPolicies />
              </Auth>
            }
          />
          <Route
            exact
            path="policy/matured-policies"
            element={
              <Auth allow="$authenticated" permission="all" redirectTo={"/"}>
                <PHMaturedPolicies />
              </Auth>
            }
          />
          <Route
            exact
            path="order/checkout"
            element={
              <Auth allow="$authenticated" permission="all" redirectTo={"/"}>
                <Checkout />
              </Auth>
            }
          />
          <Route
            exact
            path="order/response"
            element={
              <Auth allow="$authenticated" permission="all" redirectTo={"/"}>
                <Response />
              </Auth>
            }
          />

          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </BrowserRouter>
      {window !== undefined &&
        window?.location &&
        window?.location?.pathname &&
        !["/"].includes(window?.location?.pathname) &&
        !["/ldms"].includes(window?.location?.pathname) &&
        (
          <div style={{ position: "fixed", right: "10px", bottom: "10px" }}>
            <img
              alt="Call Support"
              style={{ width: "80px" }}
              src={callsupport}
            />
          </div>
        )}
    </div>
  );
}

export default App;
